import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import TableRow from '@material-ui/core/TableRow'
import { juryoTable } from 'assets/TableHeader'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCellHead'
import { organismLog } from 'utils/logUtil'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
    },
    table: {
      // backgroundColor: '#66FF99',
    },
    container: {
      maxHeight: 600,
    },
  }),
)

const width = juryoTable.width
const label = juryoTable.label

type Props = {
  isJapell: boolean
  click: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, isChecked: boolean) => void
  isChecked: boolean
  selectListCount: number
  refs: React.MutableRefObject<React.RefObject<HTMLTableCellElement>[]>
}

const O_TableHeaderJoken = ({ isJapell, click, isChecked, selectListCount, refs }: Props) => {
  useEffect(() => organismLog('O_TableHeaderJoken'))
  const classes = useStyles()

  // 固定する項目のleftを保持
  const [leftList, setLeftList] = useState<number[]>([])
  useEffect(() => {
    // 固定する項目のleftを算出
    const getLeft = (index: number) => {
      return refs.current?.reduce((prev, curr, i) => {
        if (i >= index) return prev
        if (curr.current?.getBoundingClientRect().width) prev = prev + Math.round(curr.current?.getBoundingClientRect().width * 100) / 100
        return prev
      }, 0)
    }
    const list = []
    for (let i = 0; i < refs.current.length; i++) list.push(getLeft(i))
    setLeftList(list)
  }, [...refs.current, selectListCount])

  return (
    <TableRow
      // hover //
      // onClick={(e) => click(e, isChecked)}
      className={classes.table}
    >
      {/* No */}
      {/* <M_TableCell category="number" data={'NO'} width={width.NO} /> */}
      {/* チェックボックス */}
      <M_TableCell category="checkbox" isChecked={isChecked} width={width.CHECK} click={(e) => click(e, isChecked)} refs={refs.current} refIndex={0} left={leftList[0]} />
      {/* 受領区分 */}
      <M_TableCell category="data" width={width.JURYO_KBN} title={label.JURYO_KBN} data={label.JURYO_KBN} refs={refs.current} refIndex={1} left={leftList[1]} />
      {/* 伝票日付 */}
      <M_TableCell category="data" width={width.NOHIN_YMD} title={label.NOHIN_YMD} data={label.NOHIN_YMD} refs={refs.current} refIndex={2} left={leftList[2]} />
      {/* JANコード */}
      <M_TableCell category="data" width={width.JAN_CD} title={label.JAN_CD} data={label.JAN_CD} refs={refs.current} refIndex={3} left={leftList[3]} />
      {/* 品名 */}
      <M_TableCell category="data" width={width.SHOHIN} title={label.SHOHIN} data={label.SHOHIN} refs={refs.current} refIndex={4} left={leftList[4]} />
      {/* 規格 */}
      <M_TableCell category="data" width={width.KIKAKU} title={label.KIKAKU} data={label.KIKAKU} refs={refs.current} refIndex={5} left={leftList[5]} />
      {/* 発注数 */}
      <M_TableCell category="data" width={width.SURYO} title={label.SURYO} data={label.SURYO} />
      {/* 納品数 */}
      <M_TableCell category="data" width={width.NOHIN_SURYO} title={label.NOHIN_SURYO} data={label.NOHIN_SURYO} />
      {/* 内容確認依頼 */}
      <M_TableCell category="data" width={!isJapell && selectListCount > 0 ? width.NAIYO_LONG : width.NAIYO} title={label.NAIYO} data={label.NAIYO} />
      {/* 伝票区分 */}
      <M_TableCell category="data" width={width.DENPYO_KBN} title={label.DENPYO_KBN} data={label.DENPYO_KBN} />
      {/* 伝票番号 */}
      <M_TableCell category="data" width={width.DENPYO_NO} title={label.DENPYO_NO} data={label.DENPYO_NO} />
      {/* 行 */}
      <M_TableCell category="data" width={width.GYO_NO} title={label.GYO_NO} data={label.GYO_NO} />
      {/* 原単価 */}
      <M_TableCell category="data" width={width.GEN_TANKA} title={label.GEN_TANKA} data={label.GEN_TANKA} />
      {/* 売単価 */}
      <M_TableCell category="data" width={width.BAI_TANKA} title={label.BAI_TANKA} data={label.BAI_TANKA} />
      {/* 原価金額 */}
      <M_TableCell category="data" width={width.GENKA} title={label.GENKA} data={label.GENKA} />
      {/* 売価金額 */}
      <M_TableCell category="data" width={width.BAIKA} title={label.BAIKA} data={label.BAIKA} />
      {/* 得意先名 */}
      <M_TableCell category="data" width={width.TOKUI_NM} title={label.TOKUI_NM} data={label.TOKUI_NM} />
      {/* 店名 */}
      <M_TableCell category="data" width={width.TEN_NM} title={label.TEN_NM} data={label.TEN_NM} />
      {/* 事業所名 */}
      {isJapell ? <M_TableCell category="data" width={width.JIGYO_NM} title={label.JIGYO_NM} data={label.JIGYO_NM} /> : <></>}
    </TableRow>
  )
}

export default React.memo(O_TableHeaderJoken)
